import * as React from 'react';

const PlaySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#010101"
            d="M8 7.6l8.8 4.4L8 16.4V7.6zM7 6v12l12-6L7 6z"
        />
    </svg>
);

PlaySvg.displayName = 'PlaySvg';
export default PlaySvg;
